import { apiClient, ApiResponse } from "@/shared/api";

export type LinkPreview = {
  title: string;
  description?: string;
  image?: string;
  url: string;
};

export const getLinkPreview = (
  url: string
): Promise<ApiResponse<LinkPreview>> => {
  return apiClient(`/api/link-preview?url=${encodeURIComponent(url)}`, "get");
};
